import React, { useState, useEffect, useRef } from "react";
import back_arrow from "../../assets/svg/back-arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import "../../styles/invoice_addnew.css";
import { useNavigate, useLocation } from "react-router-dom";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import info_icon from "../../assets/svg/info_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import Invoice_header from '../Header/Invoice_header'
import axios from "axios";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from "../../axiosInstance";
import CreateJobs from "./CreateJobs";
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";

const Invoice_addNew = () => {

  // let ModuleId = 10
  let ModuleId = 24
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  console.log("permission", permission);
  const { hasAdditionalPermission } = usePermissions();
  const canEditCharges = hasAdditionalPermission(ModuleId, "edit_inv_charges");
  console.log("canEditCharges", canEditCharges);





  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [summary, setSummary] = useState([]);
  const [initialSelectedJobs, setInitialSelectedJobs] = useState([]);
  const [lineitems, setLineitems] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [projectName, setProjectName] = useState("");

  const [projectId, setselectedprojectId] = useState(0);
  const [selectedChargeIds, setSelectedChargeIds] = useState({});
  const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showCreateJobPopup, setShowCreateJobPopup] = useState(false);
  const [newlyCreatedJobs, setNewlyCreatedJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState([]);



  const calculateCategoryTotals = (category) => {
    const totals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    category.rows.forEach(row => {
      totals.quantity += parseFloat(row.unitQuantity) || 0;
      totals.rate += parseFloat(row.unitRatePrice) || 0;
      totals.netValue += parseFloat(row.netTotal) || 0;
    });

    return totals;
  };

  const location = useLocation();
  useEffect(() => {
    if (location.state?.invoiceData) {
      const invoiceData = location.state.invoiceData;
      const selected_job_id = location.state.selectedJobs;
      console.log("Existing job id selected", selected_job_id);
      console.log("invoicedata for creation", invoiceData);
      console.log("initialSelectedJobs.summary....", invoiceData.summary);
      console.log("initialSelectedJobs.line_items....", invoiceData.line_items);
      setSelectedJobId(selected_job_id);
      setInitialSelectedJobs(invoiceData.line_items);
      setSummary(invoiceData.summary);
      setLineitems(invoiceData.line_items);
      setselectedprojectId(invoiceData.summary[0]?.project_id);
      setSelectedChargeIds(() => {
        const idMap = {};
        invoiceData.line_items.forEach((item, i) => {
          item.details.forEach((detail, j) => {
            idMap[`${i}_${j}`] = detail.charge_id;
          });
        });
        return idMap;
      });

      setProjectName(invoiceData.summary?.[0]?.project_name || "");
    }
  }, [location.state]);

  // Initialize state with the received jobs
  useEffect(() => {
    if (lineitems.length > 0) {
      const categories = lineitems.map(job => {
        console.log(
          `Job No: ${job.job_no} | contract_id: ${job.contract_id}`
        );
        const rows = job.details.map(detail => ({
          billingtype: "",
          elements: "",
          remarks: "",
          chargecode: detail.charge_code,
          jobIds: detail.job_id,
          jobTypeId: detail.job_type_id,
          description: detail.description,
          unitQuantity: detail.unit_of_quantity,
          unitRatePrice: detail.unit_of_rate,
          netTotal: detail.net_total,
          accrualSplit: detail.accrual,
          attachment: detail.attachment_url || "",
          existingAttachmentUrl: detail.attachment_url || "",
          uploadedFiles: [],
          isChecked: false,
          supporting_document: detail.supporting_doc ?? false,
        }));

        return {
          id: job.job_no,
          job_id: job.details[0]?.job_id || null,
          accrual: Number(job.accrual).toFixed(2),
          contract_id: job.contract_id,
          name: `Job Number-${job.job_no}`,
          jobNo: job.job_no,
          rate: 1000,
          rows: rows,
        };
      });

      console.log("categories initial check from api", categories);

      setAllCategories(categories);

      // ➕ Populate inputValues here
      const initialInputValues = {};
      categories.forEach((category, catIndex) => {
        initialInputValues[catIndex] = {};
        category.rows.forEach((row, rowIndex) => {
          initialInputValues[catIndex][rowIndex] = row.chargecode || "";
        });
      });
      setInputValues(initialInputValues);
    }
  }, [lineitems]);


  // When selected jobs change, update the categories
  useEffect(() => {
    // Create categories directly from the selectedJobs in state
    const newCategories = selectedJobs.map(jobId => {
      // Find the job in the initial selected jobs from location state
      const job = initialSelectedJobs.find(j => j.jobNo === jobId);

      return {
        id: job?.jobNo || jobId,
        jobId: job?.job_id || 0,
        name: `Job-${job?.jobNo || jobId}`,
        // quantity: job ? parseInt(job.projectCost.replace(/\D/g, '')) / 1000 || 0 : 0,
        rate: 1000, // Default rate or calculate as needed
        // netValue: job ? parseInt(job.projectCost.replace(/\D/g, '')) || 0 : 0,
        rows: [{
          billingtype: "",
          jobTypeId: "",
          chargecode: "",
          elements: "",
          remarks: "",
          description: job?.project || "",
          unitQuantity: "",
          unitRatePrice: "",
          netTotal: "",
          accrualSplit: "",
          attachment: "",
          uploadedFiles: [],
          isChecked: false,
          contract_id: null,
        }]
      };
    });

    setAllCategories(newCategories);
  }, [selectedJobs]);

  const handleJobSelection = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
    setSelectedJobs(selectedOptions);
  };

  // const handleRemoveJob = (jobIdToRemove) => {
  //   setSelectedJobs(prev => prev.filter(jobId => jobId !== jobIdToRemove));

  //   // Also remove categories associated with this job
  //   setAllCategories(prev => {
  //     const jobToRemove = jobData.find(j => j.id === jobIdToRemove);
  //     if (!jobToRemove) return prev;

  //     const categoryIdsToRemove = jobToRemove.categories.map(c => c.id);
  //     return prev.filter(cat => !categoryIdsToRemove.includes(cat.id));
  //   });
  // };



  const handleRemoveJob = async (jobIdToRemove) => {
    const confirmed = window.confirm("Are you sure you want to remove this job?");
    if (!confirmed) return;

    console.log("Existing job id", selectedJobId);
    console.log("Trying to remove:", jobIdToRemove);

    const updatedJobs = selectedJobId.filter(jobId => Number(jobId) !== Number(jobIdToRemove));
    console.log("After removed job id", updatedJobs);

    setSelectedJobs(updatedJobs);

    try {
      const invoicePayload = { job_ids: updatedJobs };
      const invoiceResponse = await axiosInstance.post('/job/generate_invoice', invoicePayload);

      if (invoiceResponse.data.success) {
        navigate("/invoice_addNew", {
          state: {
            invoiceData: invoiceResponse.data,
            selectedJobs: updatedJobs
          }
        });
      } else {
        toast.error("Failed to regenerate invoice data");
      }
    } catch (error) {
      console.error("Error regenerating invoice:", error);
      toast.error(error.response?.data?.message || "Invoice regeneration failed");
    }
  };





  const handleAttachFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const handleAttachRemoveFile = (index) => {
    const newFiles = [...uploadedFiles];
    newFiles.splice(index, 1);
    setUploadedFiles(newFiles);
  };

  const addRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: [
              ...category.rows,
              {
                billingtype: "",
                jobTypeId: category.rows[0]?.jobTypeId || "",
                chargecode: "",
                elements: "",
                description: "",
                unitQuantity: "",
                unitRatePrice: "",
                netTotal: "",
                accrualSplit: "",
                attachment: "",
                uploadedFiles: [],
                isChecked: false,
                contract_id: null,
              },
            ],
          }
          : category
      )
    );
  };

  const handleFileUpload = (e, categoryId, index, lineindex) => {
    const files = Array.from(e.target.files);

    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] } : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  uploadedFiles: row.uploadedFiles.filter((_, index) => index !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  // const handleInputChange = (e, index, rowIndex, field) => {
  //   const { value } = e.target;

  //   setAllCategories(prevCategories =>
  //     prevCategories.map((category, currentindex) =>
  //       currentindex === index
  //         ? {
  //           ...category,
  //           rows: category.rows.map((row, i) => {
  //             if (i === rowIndex) {
  //               const updatedRow = { ...row, [field]: value };

  //               if (field === 'unitQuantity' || field === 'unitRatePrice') {
  //                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
  //                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
  //                 updatedRow.netTotal = (quantity * rate).toString();
  //               }

  //               return updatedRow;
  //             }
  //             return row;
  //           }),
  //         }
  //         : category
  //     )
  //   );
  // };


  // const handleInputChange = (e, categoryId, rowIndex, field) => {
  //   const { value } = e.target;

  //   setAllCategories(prevCategories =>
  //     prevCategories.map(category =>
  //       category.id === categoryId
  //         ? {
  //           ...category,
  //           rows: category.rows.map((row, i) => {
  //             if (i === rowIndex) {
  //               const updatedRow = { ...row, [field]: value };

  //               if (field === 'unitQuantity' || field === 'unitRatePrice') {
  //                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
  //                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
  //                 updatedRow.netTotal = (quantity * rate).toString();
  //               }

  //               return updatedRow;
  //             }
  //             return row;
  //           }),
  //         }
  //         : category
  //     )
  //   );
  // };


  const handleInputChange = (e, index, rowIndex, field) => {
    const { value } = e.target;

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentindex) => {
        if (currentindex !== index) return category;

        // Update the specific row
        const updatedRows = category.rows.map((row, i) => {
          if (i === rowIndex) {
            const updatedRow = { ...row, [field]: value };

            if (field === 'unitQuantity' || field === 'unitRatePrice') {
              const quantity = parseFloat(updatedRow.unitQuantity) || 0;
              const rate = parseFloat(updatedRow.unitRatePrice) || 0;
              updatedRow.netTotal = (quantity * rate).toString();
            }

            return updatedRow;
          }
          return row;
        });

        // Recalculate summary after updating rows
        const totalQuantity = updatedRows.reduce((sum, r) => sum + (parseFloat(r.unitQuantity) || 0), 0);
        const totalRate = updatedRows.reduce((sum, r) => sum + (parseFloat(r.unitRatePrice) || 0), 0);
        const totalNetValue = updatedRows.reduce((sum, r) => sum + (parseFloat(r.netTotal) || 0), 0);

        return {
          ...category,
          rows: updatedRows,
          quantity: totalQuantity.toFixed(2),
          rate: totalRate.toFixed(2),
          netValue: totalNetValue.toFixed(2)
        };
      })
    );
  };

  const handleCheckboxChange = (e, categoryId, index) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === index ? { ...row, isChecked: e.target.checked } : row
            ),
          }
          : category
      )
    );
  };

  // const deleteRow = (categoryId, rowIndex) => {
  //   setAllCategories(prevCategories =>
  //     prevCategories.map(category => {
  //       if (category.id === categoryId) {
  //         const newRows = [...category.rows];
  //         newRows.splice(rowIndex, 1);
  //         return { ...category, rows: newRows };
  //       }
  //       return category;
  //     })
  //   );
  // };



  const deleteRow = (categoryId, rowIndex) => {
    const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

    if (categoryIndex === -1) {
      return; // Category not found, should not happen but good to check
    }

    const category = allCategories[categoryIndex];

    if (category.rows.length <= 1) {
      toast.error("At least one row must remain, cannot delete.");
      return;
    }

    setAllCategories(prevCategories =>
      prevCategories.map(cat => {
        if (cat.id === categoryId) {
          const newRows = [...cat.rows];
          newRows.splice(rowIndex, 1);
          return { ...cat, rows: newRows };
        }
        return cat;
      })
    );

    setInputValues(prevInputValues => {
      const newInputValues = { ...prevInputValues };
      if (newInputValues[categoryIndex]) {
        const rows = { ...newInputValues[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newInputValues[categoryIndex] = shiftedRows;
      }
      return newInputValues;
    });

    setSelectedChargeIds(prevSelectedChargeIds => {
      const newSelectedChargeIds = {};
      Object.keys(prevSelectedChargeIds).forEach(key => {
        const [catIndexStr, rowIdxStr] = key.split('_');
        const catIndex = Number(catIndexStr);
        const rowIdx = Number(rowIdxStr);

        if (catIndex === categoryIndex) {
          if (rowIdx < rowIndex) {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          } else if (rowIdx > rowIndex) {
            newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
          }
          // If rowIdx === rowIndex, we simply skip it (the deleted row)
        } else {
          newSelectedChargeIds[key] = prevSelectedChargeIds[key];
        }
      });
      return newSelectedChargeIds;
    });

    setSuggestionsMap(prev => {
      const newMap = { ...prev };
      if (newMap[categoryIndex]) {
        const rows = { ...newMap[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newMap[categoryIndex] = shiftedRows;
      }
      return newMap;
    });
  };


  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  const handleJobCheckboxChange = (jobId) => {
    setSelectedJobs(prev =>
      prev.includes(jobId)
        ? prev.filter(id => id !== jobId)
        : [...prev, jobId]
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleSubmit = async (actionType) => {
    
    try {
      const generateInvoiceValue = allCategories.length > 0 ? "1" : "0";

      const jobs = allCategories.map((category, categoryIndex) => ({
        id: category.rows[0]?.jobIds || 0,
        jobnumber: category.jobNo || "",
        project_id: parseInt(projectId) || 0,
        job_type_id: category.rows[0]?.jobTypeId || 0,
        job_created_date: new Date().toISOString().split("T")[0],
        job_line: category.rows.map((row, rowIndex) => {
          const attachmentKey = `${categoryIndex}_${rowIndex}`;
          const hasNewFile = row.uploadedFiles?.length > 0;

          return {
            project_id: parseInt(projectId) || 0,
            job_type_id: row.jobTypeId,
            charge_id: selectedChargeIds[attachmentKey] || 0,
            description_of_charges: row.description || "",
            unit_of_quantity: parseFloat(row.unitQuantity) || 0,
            unit_of_rate: parseFloat(row.unitRatePrice) || 0,
            net_total: parseFloat(row.netTotal) || 0,
            accrual: parseFloat(row.accrualSplit) || 0,
            attachment_key: attachmentKey,
            ...(hasNewFile ? {} : row.existingAttachmentUrl && { existing_attachment_url: row.existingAttachmentUrl }),
          };
        }),
      }));

      console.log('jobs payload', jobs);

      const payload = {
        jobs,
        actions: [actionType],
        generate_invoice: generateInvoiceValue,
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(payload));

      // Only append NEW uploaded files to formData
      allCategories.forEach((category, categoryIndex) => {
        category.rows.forEach((row, rowIndex) => {
          if (row.uploadedFiles?.length > 0) {
            row.uploadedFiles.forEach((file) => {
              const attachmentKey = `${categoryIndex}_${rowIndex}`;
              formData.append(`attachments[${attachmentKey}][]`, file);
            });
          }
        });
      });

      const response = await axiosInstance.post(
        '/invoice/save',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (response.status === 200 && response.data.success === true) {
        toast.success("Invoice saved successfully!");
        navigate("/invoice");
      } else if (response.data.success === false) {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);
      toast.error("Error while submitting: " + error.message);
    }
  };








  const calculateSummaryTotals = () => {
    return allCategories.reduce((acc, category) => {
      const categoryTotals = calculateCategoryTotals(category);
      return {
        quantity: acc.quantity + categoryTotals.quantity,
        rate: acc.rate + categoryTotals.rate,
        netValue: acc.netValue + categoryTotals.netValue
      };
    }, { quantity: 0, rate: 0, netValue: 0 });
  };

  const handleRemoveAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  attachment: "",
                  existingAttachmentUrl: "",
                  uploadedFiles: []
                }
                : row
            ),
          }
          : category
      )
    );
  };








  const fetchSuggestions = async (searchTerm = "", rowIndex, index, projectId) => {
    try {
      setSuggestionsMap([]);

      // const response = await axios.get(
      //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
      //   {
      //     params: {
      //       term: searchTerm
      //     }
      //   }
      // );

      const response = await axiosInstance.get(
        `/project_based/getchargecodes/${projectId}`,
        {
          params: {
            term: searchTerm
          }
        }
      );

      if (response.data?.chargecodes) {

        const newSuggestions = response.data?.chargecodes || [];
        setSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {}; // initialize if empty
          updated[index][rowIndex] = newSuggestions;
          console.log("Updated suggestionsMap:", updated);
          return updated;
        });

        setShowSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);

      setSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = []; // clear only that one
        return updated;
      });

      setShowSuggestionsMap(prev => ({
        ...prev,
        [`${index}_${rowIndex}`]: false,
      }));
    }
  };

  const handleJobCreated = (jobData) => {
    // Debugging: Log the incoming data
    console.log('Received jobData:', jobData);

    // Validate incoming data
    if (!jobData) {
      console.error('No job data received');
      return;
    }

    // Create a new category for the job with proper fallbacks
    const newCategory = {
      id: jobData.jobid,
      name: `Job-${jobData.jobNo}`,     // Fallback if jobNo is missing
      jobNo: jobData.jobNo || '',                // Ensure jobNo exists
      rows: (jobData.rows || []).map(row => {
        // Debug each row's chargecode
        console.log('Processing row with chargecode:', row.chargecode);

        return {
          jobTypeId: jobData.job_type_id,
          chargecode: row.chargecode,
          description: row.description || "",
          unitQuantity: row.unitQuantity || "",
          unitRatePrice: row.unitRatePrice || "",
          netTotal: row.netTotal || "",
          accrualSplit: row.netTotal || "",
          attachment: row.attachment || "",
          uploadedFiles: [],
          isChecked: false
        };
      })
    };

    // Add to allCategories
    setAllCategories(prev => [...prev, newCategory]);

    // Calculate summary only if we have valid data
    if (jobData.jobNo && jobData.rows) {
      setSummary(prev => [...prev, {
        job_no: jobData.jobNo,
        quantity: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.unitQuantity) || 0), 0),
        rate: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.unitRatePrice) || 0), 0),
        net_value: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.netTotal) || 0), 0)
      }]);
    } else {
      console.error('Missing required data for summary:', {
        hasJobNo: !!jobData.jobNo,
        hasRows: !!jobData.rows
      });
    }
  };


  return (
    <>
      <Invoice_header />
      <div className="invoice_popup">
        <div className="invoice_popup_header">
          <div className="invoice_popup_header_left">
            <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }} />
            <p className="new_cost_line">New Invoice</p>
          </div>
          <div className="invoice_popup_header_right">
            <button className="cancel_btn" onClick={() => navigate("/jobs")}>Cancel</button>
            <button className="cancel_btn" onClick={() => handleSubmit("save")}>Save</button>
            <button className="submit_btn" onClick={() => handleSubmit("submit")}>Submit</button>
          </div>
        </div>

        <div className="invoice_popup_project">
          <div className="invoice-popup-project-content">
            <p className="invoice-popup-project-project">Project</p>
            <p className="invoice-popup-project-project-name">{projectName}</p>
          </div>
          <div className="invoice-popup-project-summary">
            <p className="invoice-popup-summary-summary">Summary</p>
            <table className="invoice-popup-summary-table">
              <thead>
                <tr>
                  <th>Jobs</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>Net Value</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((job, index) => (
                  <tr key={index}>
                    <td>{job.job_no}</td>
                    <td>{job.quantity}</td>
                    <td>{job.rate}</td>
                    <td>{job.net_value}</td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td>Total</td>
                  <td>
                    {summary.reduce((sum, job) => sum + parseFloat(job.quantity || 0), 0).toFixed(2)}
                  </td>
                  <td>
                    {summary.reduce((sum, job) => sum + parseFloat(job.rate || 0), 0).toFixed(2)}
                  </td>
                  <td>
                    {summary.reduce((sum, job) => sum + parseFloat(job.net_value || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="invoice_popup_categories">

          <AdditionalPermissionWrapper permissionKey="create_jobs" moduleId={ModuleId}>
            <div
              className="invoice-generate-job"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px 20px",
              }}
            >
              <button className="invoice-generate-job-btn" onClick={() => setShowPopup(true)}>
                Create Job
              </button>
            </div>
          </AdditionalPermissionWrapper>

          {showPopup && (
            <CreateJobs
              onClose={() => setShowPopup(false)}  // This will close the popup
              onJobCreated={(jobData) => {
                handleJobCreated(jobData);
                setShowPopup(false);
              }}
              projectId={projectId}
              projectName={projectName}
              selectedJobId={selectedJobId}
            />
          )}

          {allCategories.map((category, index) => {
            // console.log("category data check", category),

            const isContract = category.contract_id !== null;
            const contractLabel = isContract ? "C" : "NC";
            console.log("contractLabellllllllll", contractLabel);
            const contractColor = isContract ? "#129990" : "#FFB22C";

            return (
              <div key={category.id} className="invoice_popup_outercategory">
                <div className="invoice_popup_category_header">
                  <div
                    className="category_name_left"
                    style={{
                      display: "flex",
                      alignItems: "center", // vertical center
                      justifyContent: "center", // horizontal center
                      gap: "8px", // spacing between text and image
                    }}
                  >
                    <span className="category_name">Job No - {category.id}</span>

                    <span
                      style={{
                        backgroundColor: contractColor,
                        color: "#fff",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                      }}
                    >
                      {contractLabel}
                    </span>

                    <AdditionalPermissionWrapper permissionKey="remove_jobs" moduleId={ModuleId}>
                      <img
                        src={delete_icon}
                        style={{ width: '25px', height: '25px', cursor: 'pointer' }}
                        alt="Delete"
                        onClick={() => handleRemoveJob(category.job_id)}
                      />
                    </AdditionalPermissionWrapper>

                  </div>

                  <div className="category_name_left">
                    <span className="category_name_netvalue">
                      Accrual : <span className="number_highlight">
                        {category.accrual}
                      </span>
                    </span>
                  </div>
                  <div className="category_name_right">
                    <span className="category_name_quantity">
                      Quantity : <span className="number_highlight">
                        {category.rows.reduce((sum, row) => sum + (parseFloat(row.unitQuantity) || 0), 0).toFixed(2)}</span>
                    </span>
                    <img src={small_line} alt="" />
                    <span className="category_name_rate">
                      Rate : <span className="number_highlight">
                        {category.rows.reduce((sum, row) => sum + (parseFloat(row.unitRatePrice) || 0), 0).toFixed(2)}</span>
                    </span>
                    <img src={small_line} alt="" />
                    <span className="category_name_netvalue">
                      Net Value :
                      {(() => {
                        const netTotal = category.rows.reduce(
                          (sum, row) => sum + (parseFloat(row.netTotal) || 0), 0
                        );
                        const accrual = parseFloat(category.accrual) || 0;
                        const difference = netTotal - accrual;
                        const isPositive = difference >= 0;

                        return (
                          <>
                            <span className="number_highlight">{netTotal.toFixed(2)}</span>
                            &nbsp;
                            <span className={isPositive ? "diff_positive" : "diff_negative"}>
                              ({isPositive ? '+' : ''}{difference.toFixed(2)})
                            </span>
                          </>
                        );
                      })()}
                    </span>
                  </div>
                </div>

                <div className="invoice_popup_category_subheader">
                  <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                    <div className="table-container">
                      <table className="invoice_table">
                        <thead>
                          <tr>
                            <th>CHARGE CODE</th>
                            {/* <th>REMARKS</th> */}
                            <th>DESCRIPTION OF CHARGES</th>
                            <th>ACCRUAL SPLIT</th>
                            <th>UNIT OF QUANTITY</th>
                            <th>UNIT RATE PRICE</th>
                            <th>NET TOTAL</th>
                            <th>ATTACHMENT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {category.rows.map((row, lineindex) => {
                            console.log("Row detailsssssssss", row);
                            console.log("contractId checkkkkkkkkkkkkk", category);

                            const rowContractId = row.contract_id !== undefined ? row.contract_id : category.contract_id;
                            const isNonContract = rowContractId == null;
                            const canEditChargeDetails = canEditCharges && isNonContract;


                            const canEditQuantityRate = canEditCharges;


                            console.log("row.contract_id:", row.contract_id);
                            console.log("rowContractId:", rowContractId);
                            console.log("canEditChargeDetails:", canEditChargeDetails);

                            return (
                              <tr key={lineindex}>
                                <td style={{ position: "relative" }}>
                                  <input
                                    type="text"
                                    // value={inputValues[index]?.[lineindex] || ""}
                                    value={inputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                    onChange={(e) => {
                                      console.log("canEditChargeDetailsssssssssss", canEditChargeDetails);
                                      if (!canEditChargeDetails) return;
                                      const val = e.target.value;
                                      handleInputChange(e, index, lineindex, "chargecode");
                                      setInputValues((prev) => ({
                                        ...prev,
                                        [index]: {
                                          ...prev[index],
                                          [lineindex]: val,
                                        },
                                      }));
                                      fetchSuggestions(val, lineindex, index, projectId);
                                    }}
                                    onFocus={() => {
                                      if (!canEditChargeDetails) return;
                                      const list = suggestionsMap[index]?.[lineindex] || [];
                                      if (list.length > 0) {
                                        const list = suggestionsMap[index]?.[lineindex] || [];
                                        if (list.length > 0) {
                                          setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                        }
                                      }
                                    }}
                                    onBlur={() => {
                                      setTimeout(() => {
                                        setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                      }, 200);
                                    }}
                                    className="invoice_small_input"
                                    placeholder="Search"
                                    disabled={!canEditChargeDetails}
                                  />

                                  {showSuggestionsMap[`${index}_${lineindex}`] && suggestionsMap[index]?.[lineindex]?.length > 0 && (
                                    <ul
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        zIndex: 999,
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        margin: 0,
                                        padding: 0,
                                        listStyle: "none",
                                      }}
                                    >
                                      {suggestionsMap[index]?.[lineindex].map((item) => (
                                        <li
                                          key={item.value}
                                          onMouseDown={() => {
                                            const selected = item.label;
                                            const chargeId = item.value;
                                            const supporting_doc = item.value1; // new


                                            setInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: selected,
                                              },
                                            }));

                                            setSelectedChargeIds((prev) => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: chargeId
                                            }));

                                            handleInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));


                                            // ✨ NEW PART: split and set description separately ✨
                                            const splitParts = selected.split("-");
                                            const chargeCodeOnly = splitParts[0] || "";
                                            const descriptionOnly = splitParts.slice(1).join("-") || "";


                                            // Update charge code field value (CT002)
                                            setInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: chargeCodeOnly,
                                              },
                                            }));

                                            handleInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                            // Update description field value (TestCharge)
                                            handleInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");


                                            // 🔥 Update supporting doc flag in that row
                                            setAllCategories(prev =>
                                              prev.map((cat, catIndex) =>
                                                catIndex === index
                                                  ? {
                                                    ...cat,
                                                    rows: cat.rows.map((row, rIndex) =>
                                                      rIndex === lineindex
                                                        ? { ...row, supporting_document: !!supporting_doc }
                                                        : row
                                                    ),
                                                  }
                                                  : cat
                                              )
                                            );

                                          }}
                                          style={{
                                            padding: "8px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          {item.label}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </td>

                                {/* <td>
                                    <input
                                      type="text"
                                      value={row.remarks}
                                      onChange={(e) => handleInputChange(e, category.id, index, "remarks")}
                                      className="invoice_small_input"
                                    />
                                  </td>   */}

                                <td>
                                  <input
                                    type="text"
                                    value={row.description}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "description")}
                                    onChange={(e) => {
                                      if (!canEditChargeDetails) return;
                                      handleInputChange(e, index, lineindex, "description");
                                    }}
                                    className="invoice_small_input"
                                    disabled={!canEditChargeDetails}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.accrualSplit ? row.accrualSplit : 0}
                                    readOnly
                                    className="invoice_small_input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.unitQuantity}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "unitQuantity");
                                    }}
                                    className="invoice_small_input"
                                  // disabled={!canEditQuantityRate}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.unitRatePrice}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitRatePrice")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "unitRatePrice");
                                    }}
                                    className="invoice_small_input"
                                  // disabled={!canEditQuantityRate}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.netTotal}
                                    readOnly
                                    className="invoice_small_input"
                                  />
                                </td>
                                <td className="attachment-cell">
                                  {/* Upload or View */}
                                  {!row.uploadedFiles || row.uploadedFiles.length === 0 ? (
                                    row.attachment ? (
                                      <div className="attachment_view_section">
                                        <a
                                          href={row.attachment}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="view_link"
                                        >
                                          <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                          <span className="view_text">View</span>
                                        </a>
                                        <button
                                          className="remove_file_btn"
                                          onClick={() => handleRemoveAttachment(category.id, index, lineindex)}
                                        >
                                          ⨉
                                        </button>
                                      </div>
                                    ) : (
                                      <label className="file_upload">
                                        <input
                                          type="file"
                                          multiple
                                          onChange={(e) => handleFileUpload(e, category.id, index, lineindex)}
                                          style={{ display: "none" }}
                                        />
                                        <img src={upload_icon} alt="Upload" className="upload_icon" />
                                        <span className="upload_text">
                                          Upload{" "}
                                          {row.supporting_document && (
                                            <span style={{ color: "red" }}>(Required*)</span>
                                          )}
                                        </span>
                                      </label>
                                    )
                                  ) : null}

                                  {/* Uploaded Files */}
                                  {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                    <div className="uploaded_files">
                                      {row.uploadedFiles.map((file, fileIndex) => (
                                        <div key={fileIndex} className="uploaded_file_item">
                                          <img
                                            src={
                                              file.name.endsWith(".xls") || file.name.endsWith(".xlsx")
                                                ? excel_icon
                                                : upload_icon
                                            }
                                            alt="File"
                                            className="file_icon"
                                          />
                                          <span className="file_name">{file.name}</span>
                                          <button
                                            className="remove_file_btn"
                                            onClick={() =>
                                              handleRemoveFile(category.id, index, lineindex, fileIndex)
                                            }
                                          >
                                            ⨉
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {/* {category.contract_id == null && ( */}
                      <div className="static-delete-container">
                        {category.rows.map((row, index) => (
                          <div key={index} className="static-delete-btn">
                            <button onClick={() => deleteRow(category.id, index)}>
                              <img src={delete_icon} alt="Delete" className="delete_icon" />
                            </button>
                          </div>
                        ))}
                      </div>
                      {/* )} */}
                    </div>

                    {/* {category.contract_id == null && ( */}
                    <div
                      className="add_new_row"
                      onClick={() => addRow(category.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="add_new_row_popup">
                        <img src={plus_icon} alt="" />
                        Add Row
                      </span>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  )
}

export default Invoice_addNew;